
















































import { defineComponent, onMounted, PropType } from "@vue/composition-api"
import { useProgressExchangeBus } from "@/shared/composables/progressExchangeBus"
import { useActions, useGetters } from "vuex-composition-helpers"
import { ILabels } from "@/apps/StudentExchangeNonPartnerWidget/models/config-viewmodel"
import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import ExchangePeriod from "@/apps/StudentExchangeNonPartnerWidget/components/ExchangePeriod.vue"
import ExchangeContact from "@/apps/StudentExchangeNonPartnerWidget/components/ExchangeContact.vue"
import ExchangeInstitution from "@/apps/StudentExchangeNonPartnerWidget/components/ExchangeInstitution.vue"
import ExchangeInsurance from "@/apps/StudentExchangeNonPartnerWidget/components/ExchangeInsurance.vue"
import ExchangeSubmit from "@/apps/StudentExchangeNonPartnerWidget/components/ExchangeSubmit.vue"
import ModalComponent from "@/apps/StudentExchangeNonPartnerWidget/components/ModalComponent.vue"

export default defineComponent({
    name: "StudentExchangeNonPartnerWidget",
    components: {
        ModalComponent,
        ExchangeInsurance,
        ExchangeInstitution,
        ExchangePeriod,
        ExchangeContact,
        ExchangeSubmit,
        ExchangeCard
    },
    props: {
        labels: {
            type: Object as PropType<ILabels>,
            required: true
        },
        programId: {
            type: Number,
            required: true
        },
        exchangeId: {
            type: String,
            required: false,
        },
        academicYearId: {
            type: Number,
            required: true
        },
        language: {
            type: String,
            required: true
        }
    },
    setup(props: any) {
        const {
            setLabels,
            setLanguage,
            loadStudyName,
            setProgramId,
            setExchangeId,
            setAcademicYearId,
            loadStudentExchangeNonPartner
        } = useActions([
            'setLabels',
            'setLanguage',
            'loadStudyName',
            'setProgramId',
            'setExchangeId',
            'setAcademicYearId',
            'loadStudentExchangeNonPartner'
        ])
        const {
            getLabels,
            getLanguage,
            getStudyName,
            getIsSubmitted,
        } = useGetters([
            'getLabels',
            'getLanguage',
            'getStudyName',
            'getIsSubmitted'
        ])
        setLabels(props.labels)
        setProgramId(props.programId)
        setExchangeId(props.exchangeId)
        setAcademicYearId(props.academicYearId)
        setLanguage(props.language)
        
        onMounted(async () => {
            loadStudyName()
            loadStudentExchangeNonPartner(props.exchangeId)
            useProgressExchangeBus().progress.push(getLabels.value.programOfStudyBlockTitle)
        })
        
        function complete() {
            window.open(`/${getLanguage.value}/exchange/overview/`, '_self')
        }
        
        return {
            complete,
            getLabels,
            getStudyName,
            getIsSubmitted
        }
    }
})
